import { Platform } from 'react-native';

/**
 * Opens the browser's file / camera picker for one image. There is no upload
 * endpoint yet, so callers store a `upload://<filename>` placeholder reference.
 */
export const pickImage = (): Promise<File | null> => {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return Promise.resolve(null);
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.display = 'none';
    input.addEventListener('change', () => {
      resolve(input.files?.[0] ?? null);
      input.remove();
    });
    // Picker dismissed: modern browsers fire `cancel` on the input.
    input.addEventListener('cancel', () => {
      resolve(null);
      input.remove();
    });
    document.body.appendChild(input);
    input.click();
  });
};

export const uploadPlaceholder = (file: File): string => `upload://${file.name}`;
